import 'es6-shim';
import 'es7-shim';
import 'url-search-params-polyfill';

import React, {Component} from 'react';
import Layout from './layout/Layout'


import './App.css';
import {withAuthentication} from './services/Authentication';


class App extends Component {

  render() {
    return (

        <Layout/>
    );
  }
}


export default withAuthentication(App);



// WEBPACK FOOTER //
// ./src/App.js